module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Enchanters: Royal Secrets")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-1-entering-the-unknown"
    }
  }, [_vm._v("Chapter 1: Entering the Unknown")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-2-the-curse-of-eneas"
    }
  }, [_vm._v("Chapter 2: The Curse of Eneas")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-3-silverstring-academy-for-enchanters-and-enchantresses"
    }
  }, [_vm._v("Chapter 3: Silverstring\n          Academy for Enchanters and Enchantresses")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-4-the-three-tribes-and-the-academy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: The Three Tribes\n          and the Academy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-5-silverstring-street-and-defensive-magic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5:\n          Silverstring Street and Defensive Magic")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-6-his-vulnerable-side-the-greatest-power-mark-and-maldeus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: His\n          Vulnerable Side, the Greatest Power Mark, and Maldeus")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-7-the-date-aristera-and-the-encounter-with-real-defense",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Date,\n          Aristera, and the Encounter with Real Defense")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-8-andronicuss-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Andronicus’s Day")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-9-the-most-powerful-bond",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Most Powerful\n          Bond")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-10-the-man-behind-the-black-mask",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: The Man behind\n          the Black Mask")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-11-dark-encounter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Dark Encounter")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-12-the-union-bond",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: The Union Bond")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-13-the-end",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: The End?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-14-the-remaining-evil",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: The Remaining Evil")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-15-the-afterlife",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: The Afterlife")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-16-the-world-sees-the-mask-justice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: The World Sees\n          the Mask, Justice")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-17-bran-beciles-secret",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Bran Becile’s Secret")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-18-the-pearl-of-echo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: The Pearl of Echo")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-19-what-is-happily-ever-after",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: What Is Happily\n          Ever After?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#epilogue-one-month-later",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: One Month Later")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0